import { render, staticRenderFns } from "./OrderPurchase.vue?vue&type=template&id=195d6460&scoped=true"
import script from "./OrderPurchase.vue?vue&type=script&lang=js"
export * from "./OrderPurchase.vue?vue&type=script&lang=js"
import style0 from "./OrderPurchase.vue?vue&type=style&index=0&id=195d6460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195d6460",
  null
  
)

export default component.exports